<template>
    <v-card class="wrong-answer-card pa-4 pa-md-6 mb-4" :class="{'bordered': !isDark, 'surface': isDark}" flat>
        <div class="d-flex justify-space-between align-center flex-wrap mb-1">
            <div class="d-flex align-center flex-wrap">
                <v-chip label small outlined class="primary--text text--darken-1 font-weight-bold px-2 me-2" style="height: 22px;">
                    <v-icon size="15" color="primary darken-1" class="me-1">{{isHomework ? 'mdi-book-edit-outline' : 'mdi-clipboard-text-outline'}}</v-icon>
                    {{isHomework ? 'واجب' : 'امتحان'}}
                </v-chip>
                <span class="strong-text--text details-text font-weight-bold">{{attempt.exam ? attempt.exam.name : ''}}</span>
                <span v-if="attempt.exam && attempt.exam.duration" class="muted--text details-text ms-1">({{attempt.exam.duration}} دقيقة)</span>
            </div>
            <v-chip v-if="attempt.created_at" label small outlined class="ltr-dir px-2" style="height: 22px;">{{dateTimeFormat(attempt.created_at, true).split(' ')[0]}}</v-chip>
        </div>

        <div class="question-header d-flex justify-space-between my-4">
            <div>
                <span class="error--text">
                    <v-icon color="error">mdi-close-thick</v-icon>
                    إجابة خاطئة
                </span>
                <span v-if="attempt.question_mark" class="font-weight-medium ms-1" style="font-size: 1rem">({{unitFormat(attempt.question_mark, 'درجة', 'درجتان', 'درجات')}})</span>
            </div>
        </div>

        <question-display :question="attempt.question" :chosen-answer="attempt.answer_id" show-detailed-result :answer-correct="false" />
    </v-card>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import QuestionDisplay from '@/components/custom/question-display'

export default {
    name: 'wrong-answer-card',
    components: {
        QuestionDisplay
    },
    props: {
        attempt: {required: true}
    },
    computed: {
        ...GlobalComputed,
        isHomework(){
            return this.attempt.exam && this.attempt.exam.type === 'homework';
        },
    },
    methods: {
        ...GlobalMethods,
    }
}
</script>

<style lang="scss" scoped>
    .wrong-answer-card{
        border-radius: 10px!important;
        .question-header{
            font-size: 1.2rem;
            font-weight: bold;
        }
    }
</style>
